<template>
  <List
    :class="[
      $style.toolbar,
      {
        [$style.xAxis]: axis !== 'y',
        [$style.yAxis]: axis === 'y',
        [$style.scroll]: scroll
      }
    ]"
    :keyName="keyName"
    :list="items"
    :tag="tag"
  >
    <template #first v-if="$slots['toolbar-control']">
      <slot name="toolbar-control" />
    </template>
    <template #default="{ index, item }">
      <slot :index="index" :item="item" />
    </template>
    <template #last v-if="$slots['toolbar-last']">
      <slot name="toolbar-last" />
    </template>
  </List>
</template>

<script>
import List from '@/components/atoms/List';

export default {
  name: 'Toolbar',
  components: { List },
  props: {
    // `x` or `y`
    axis: {
      default: 'x',
      required: false,
      type: String
    },
    items: {
      required: false,
      type: Array
    },
    keyName: {
      required: false,
      type: [Function, String]
    },
    scroll: {
      default: true,
      type: Boolean
    },
    tag: String
  }
};
</script>

<style module>
.toolbar {
  display: flex;
  overflow: hidden;
}

.x-axis {
  &.scroll:hover {
    overflow-x: auto;
  }
}

.y-axis {
  flex-direction: column;

  &.scroll:hover {
    overflow-y: auto;
  }
}
</style>
